module.exports = __webpack_public_path__ + "img/1549244162.79ec8774.jpg";